/**
 * M.2 — NIPE tool: listSkills
 *
 * Read-only. Returns SKILL.md frontmatter (name + description) for every
 * Skill registered in the current portal.
 */

import type { NipeTool } from './types';

export interface ListSkillsContext {
  listSkills: () => Promise<
    Array<{ name: string; description?: string; body?: string }>
  >;
}

export const listSkillsTool: NipeTool<ListSkillsContext> = {
  schema: {
    type: 'function',
    function: {
      name: 'listSkills',
      description:
        'List the SKILL.md frontmatter for every Skill registered in the current portal. Returns name and description for each.',
      parameters: { type: 'object', properties: {}, required: [] },
    },
  },
  mutatesRemote: false,
  requiresApproval: false,
  handler: async (_args, ctx) => {
    const skills = await ctx.listSkills();
    return {
      skills: skills.map((s) => ({
        name: s.name,
        description: s.description ?? '',
      })),
    };
  },
};
